import React from 'react';
import { TrendingUp } from 'lucide-react';

interface HeroProps {
  stats: {
    totalProcessed: number;
    inCriteria: number;
    gettingBetter: number;
    fallingAway: number;
  };
}

/**
 * Hero section with headline and stats
 */
export function Hero({ stats }: HeroProps) {
  return (
    <section className="hero">
      <div className="hero-content">
        <p className="eyebrow">
          <TrendingUp size={14} style={{ display: 'inline-block', marginRight: '8px' }} />
          Indian Equity
        </p>
        <h1>Scanner</h1>
        <p className="lede">
          Nifty 500 scanned daily. Know what's setting up, what's holding, and what's done.
        </p>
      </div>

      <div className="hero-card">
        <div className="stat-box">
          <span>Universe</span>
          <strong>{stats.totalProcessed}</strong>
        </div>
        <div className="stat-box">
          <span>BUY</span>
          <strong>{stats.inCriteria}</strong>
        </div>
        <div className="stat-box">
          <span>HOLD</span>
          <strong>{stats.gettingBetter}</strong>
        </div>
        <div className="stat-box">
          <span>SELL</span>
          <strong>{stats.fallingAway}</strong>
        </div>
      </div>
    </section>
  );
}
